import steam from '@op/assets/svg/channel/steam.svg';
import { FilterKeys, GroupConfigType, TFilterGroupKeys } from '../types';

const popular: FilterKeys[] = [
  'zoneGames',
  'date',
  'language',
  'genreGameAndAffinity',
  'gameAffinitys',
  'channel',
  'sentiment',
  'topic',
  'reviewType',
  'followerRange',
  'videoAITag',
];

// , 'VideoType', 'Official/Earned'
const social: FilterKeys[] = [
  'monitor',
  'videoType',
  'keyKol',
  'postAuthorType',
  'kolRegion',
  'blackGrayAuthor',
  'aigc',
];

const brandAndEngagement: FilterKeys[] = [
  'views',
  'engagementsRange',
  'commentsRange',
  'likesRange',
  'sharesRange',
];

const engagement: FilterKeys[] = [
  ...brandAndEngagement,
  'newsUVPM',
  'engagementPerformance',
];

const brandPerformance: FilterKeys[] = [
  'genreGameList',
  'brandAffinitys',
  ...brandAndEngagement,
  'brandRelatedPublications',
  'brandRelatedAvgViews',
  'genre',
  'kolTags',
  'influencersType',
  'postStream',
];

const performanceList: FilterKeys[] = [
  'totalPublications',
  'avgViews',
  'avgEngagementRate',
];

const gameStore: FilterKeys[] = [
  'steamRating',
  'rating',
  'monitorSource',
  'platformGame',
  'platform',
  'version',
  'xboxEdition',
];

// 以下的筛选器需要进行收起等操作
export const packGameStore: FilterKeys[] = [
  'steamIds',
  'starredTag',
  'refunded',
  'freePlayed',
  'steamPurchase',
  'funnys',
  'helpfuls',
  'recordTimes',
  'reviewTimes',
  'earlyAccess',
  'product',
];

const news: FilterKeys[] = [
  'newsDataSource',
  'newsCoverageType',
  'newsBate',
  'matchedType',
];

const NLPTag: FilterKeys[] = [
  'invalid',
  'keywordFilterType',
  'keyWords',
  'sentimentClause',
  'subTopicSentiment',
];

const others: FilterKeys[] = [
  'gameType',
  'competitorGames',
  'reviewers',
  'urlAnalysis',
  // 'reviewerType',
  'NIKKE',
  'hero',
  'hashtag',
  'gptSelect',
  'channelType',
  'dataSource',
  'videoTag',
  'channelTypeSingle',
  'perspective',
  'liveVenues',
  'versionTime',
  'sentimentEditStatus',
  'commentsUnderThePostContainingKeywordsIncluded',
  'region',
  'regionAndLanguage',
];

function groupList(config: GroupConfigType): Array<{
  text: string;
  list: FilterKeys[];
  value: TFilterGroupKeys;
  packList?: FilterKeys[];
  packText?: string;
  packIcon?: string;
  isMax?: boolean;
}> {
  const { isBrandPage = false } = config;

  function filterList(
    list: FilterKeys[],
    filterList: FilterKeys[],
    isInclude = false,
  ) {
    const result = list.filter(it => {
      // 过滤列表是否包含
      const flag = filterList.includes(it);

      // 不在过滤列表的都直接放出来
      if (!flag) return true;

      // 如果包含在过滤列表,就看是否包含
      return isInclude;
    });

    return result;
  }

  return [
    { text: 'Popular', value: 'popular', list: popular },
    { text: 'Social Media', value: 'social', list: social },
    {
      text: 'Brand Performance',
      value: 'brand',
      list: filterList(brandPerformance, brandAndEngagement, isBrandPage),
      isMax: true,
    },
    { text: 'Performance-1', value: 'performance', list: performanceList },
    { text: 'News-2', value: 'news', list: news },
    {
      text: 'Game Store',
      value: 'game_store',
      list: gameStore,
      packList: packGameStore,
      packText: 'Steam Related',
      packIcon: steam,
    },
    { text: 'NLP Tag', value: 'nlp', list: NLPTag },
    {
      text: 'Engagement-3',
      value: 'engagement',
      list: filterList(engagement, brandAndEngagement, !isBrandPage),
    },
    { text: 'Others', value: 'others', list: others },
    { text: 'AI Options', value: 'gpt', list: ['gptPreview'] },
    {
      text: 'Query',
      value: 'gpt',
      list: ['keywrodInputPreview', 'topicInputPreview'],
    },
    { text: 'Keyword', value: 'keyword', list: ['keywordPreview'] },
    { text: 'URL', value: 'url', list: ['urlPreview'] },
    { text: 'Agent', value: 'gptAgent', list: ['gptAgent', 'gptTriggerAgent'] },
    { text: 'Type', value: 'gptType', list: ['gptType'] },
    {
      text: 'Analysis Target',
      value: 'gptAnalysisTarget',
      list: ['gptAnalysisTarget'],
    },
  ];
}

const maxTitleList = ['brand'];
export function getGroupList(
  filter: FilterKeys[],
  groupConfig: GroupConfigType = {},
) {
  let isMax = false;

  const list = groupList(groupConfig).map(item => {
    const { text, value, list, packList = [], packText, packIcon } = item;

    const renderList = list.filter(key => filter.includes(key));

    const renderPackList = packList.filter(key => filter.includes(key));

    const isPack = renderPackList.length > 0;

    if (renderList.length === 0 && !isPack) return null;

    if (maxTitleList.includes(value)) isMax = true;

    return {
      text,
      list: renderList,
      packList: renderPackList,
      isPack,
      packText,
      packIcon,
      value,
    };
  });
  return { list, isMax };
}
